module.exports = __webpack_public_path__ + "img/home2.14c0efc8.png";